<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Veículo</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('veiculo.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'veiculo'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/veiculo"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="veiculo_id"
                    pagination-path=""
                    detail-row-component="veiculo-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('veiculo.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <a
                          @click="sendDoc(props.rowData.veiculo_id)"
                          v-b-tooltip
                          title="Enviar Documento"
                          ><i class="fa fa-id-card-o"></i
                        ></a>
                        <span v-if="getPermissionFw('veiculo.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                        <a
                          @click="onEventoGerRisco(props.rowData, 1)"
                          v-b-tooltip
                          title="Cadastrar gerenciamento risco"
                          ><i class="fa fa-plus"></i
                        ></a>
                        <a
                          @click="onEventoGerRisco(props.rowData, 5)"
                          v-b-tooltip
                          title="Enviar foto gerenciamento risco"
                          ><i class="fa fa-picture-o"></i
                        ></a>
                        <a
                          @click="onEventoGerRisco(props.rowData, 2)"
                          v-b-tooltip
                          title="Consultar gerenciamento risco"
                          ><i class="fa fa-compass"></i
                        ></a>
                        <a
                          @click="onEventoGerRisco(props.rowData, 3)"
                          v-b-tooltip
                          title="Pesquisa gerenciamento risco"
                          ><i class="fa fa-search"></i
                        ></a>
                        <a
                          @click="onEventoGerRisco(props.rowData, 4)"
                          v-b-tooltip
                          title="Pesquisa expressa gerenciamento risco"
                          ><i class="fa fa-bolt"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendDocForm ref="senddocform" :rota="'veiculo'" />
      <VeiculoForm
        ref="veiculoform"
        :metodo="onFilterReset"
        :tabela="'veiculo'"
        :rota="'veiculo'"
      >
      </VeiculoForm>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import VeiculoFilterBar from "./VeiculoFilterBar";
import VeiculoForm from "./VeiculoForm";
import VeiculoDetalhes from "./VeiculoDetalhes";
import SendDocForm from "./SendDocForm.vue";

Vue.component("veiculo-detalhes", VeiculoDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    VeiculoForm,
    SendDocForm,
    "vuetable-filterbar": VeiculoFilterBar
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingExp: false,
      helpForm: new Form({
        veiculo_ids: [],
        status: "",
        search: "",
        veiculo_id: "",
        tipo_evento: ""
      }),
      optionsLivStatus: [],
      optionsMunicipio: [],
      optionsParamTipoRodado: [],
      optionsParamTipoVeiculo: [],
      optionsParamTipoCarroceria: [],
      optionsParamTipoPropriedade: [],
      optionsParamTipoProprietario: [],
      optionsCor: [],
      optionsIsBlindado: [],
      optionsMarca: [],
      optionsTpCambio: [],
      optionsTpCombustivel: [],
      optionsTipoVeiculo: [],
      optionsCliente: [],
      form: new Form({
        placa: "",
        renavam: "",
        capacidade_kg: "",
        capacidade_m3: "",
        tara: "",
        pessoa_proprietario: [],
        tp_veiculo: [],
        tp_carroceria: [],
        tp_rodado: [],
        tp_proprietario: [],
        status: [],
        municipio: [],
        cor: [],
        is_blindado: [],
        marca: [],
        tp_cambio: [],
        tp_veiculo_det: [],
        tp_combustivel: [],
        modelo: "",
        chassi: "",
        ano_fabricacao: "",
        ano_modelo: "",
        cilindradas: "",
        potencia: "",
        obs: "",
        veiculo_id: ""
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "placa",
          title: "Placa",
        },
        {
          name: "param_tipo_veiculo.descr",
          title: "Tipo de veículo"
        },
        {
          name: "param_tipo_carroceria.descr",
          title: "Carroceria"
        },
        {
          name: "param_tipo_rodado.descr",
          title: "Tipo Rodado"
        },
        {
          name: "param_tipo_proprietario.descr",
          title: "Proprietário"
        },
        {
          name: "renavam",
          title: "Revanam",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  },
  methods: {
    onDetail(data, field, event) {
      if (data.veiculo_detalhe) {
        this.$refs.vuetable.toggleDetailRow(data.veiculo_id);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        placa: data_filter.placa,
        dt_expiracao_ini: data_filter.dt_expiracao_ini,
        dt_expiracao_fim: data_filter.dt_expiracao_fim,
        tp_situacao: data_filter.tp_situacao.value,
        renavam: data_filter.renavam,
        status: data_filter.status.value,
        tp_veiculo: data_filter.tp_veiculo.value,
        param_tp_veiculo: data_filter.param_tp_veiculo.value
      };
      if(data_filter.tp_situacao.value == 0){
        this.moreParams.tp_situacao = 99;
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.veiculoform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.veiculo_id;
      this.$refs.veiculoform.onEdit(data, index, this.id);
    },
    sendDoc(data) {
      this.$refs.senddocform.onCreate(data);
    },
    onEventoGerRisco(data, tipo_evento) {

      this.helpForm.veiculo_id = data.veiculo_id;
      this.helpForm.tipo_evento = tipo_evento;
      this.helpForm
        .post("/api/veiculo/gerenciamentorisco")
        .then(response => {
          new ReturnApi(response, this);

        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.veiculo_ids = [data.veiculo_id];
      } else {
        this.helpForm.veiculo_ids = this.$refs.vuetable.selectedTo;
      }
      this.$refs.veiculoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      }
    }
  }
};
</script>
